import React from 'react';
import '../../assets/css/elements/farm-details.css';

const FarmDetails = ({ farm, onClose }) => {
    if (!farm) return null;

    return (
        <div className="farm-details-modal">
            <div className="modal-content">
                <button className="close-button" onClick={onClose}>&times;</button>
                <h2>{farm.name}</h2>
                
                <div className="details-grid">
                    <div className="detail-item">
                        <label>Address</label>
                        <p>{farm.address}</p>
                    </div>
                    <div className="detail-item">
                        <label>Location</label>
                        <p>{farm.city}, {farm.state}</p>
                    </div>
                    <div className="detail-item">
                        <label>Size</label>
                        <p>{farm.size} hectares</p>
                    </div>
                    <div className="detail-item">
                        <label>Capacity</label>
                        <p>{farm.capacity || 'N/A'}</p>
                    </div>
                    <div className="detail-item">
                        <label>Species</label>
                        <p>{farm.species || 'N/A'}</p>
                    </div>
                    <div className="detail-item">
                        <label>Water Source</label>
                        <p>{farm.water_source || 'N/A'}</p>
                    </div>
                    <div className="detail-item">
                        <label>Established Date</label>
                        <p>{new Date(farm.established_date).toLocaleDateString()}</p>
                    </div>
                    {farm.latitude && farm.longitude && (
                        <div className="detail-item">
                            <label>Coordinates</label>
                            <p>{farm.latitude}, {farm.longitude}</p>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default FarmDetails;
